import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function ScarcitySection() {
  return <section className="py-8 px-4 bg-brand-red/10 border-y border-brand-red/20" data-id="element-189">
      <div className="container mx-auto max-w-4xl flex items-center justify-center text-center" data-id="element-190">
        <AlertTriangle className="w-6 h-6 text-brand-red mr-3 animate-pulse" data-id="element-191" />
        <p className="text-brand-red font-bold uppercase tracking-wide" data-id="element-192">
          Este precio es de lanzamiento. Puede subir sin previo aviso.
        </p>
      </div>
    </section>;
}